<template>
  <div class="jfjl">
    <van-nav-bar
        title="缴费记录"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="margin0"/>

    <van-cell v-model="C_Code" icon="user-circle-o" size="large" >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{C_Name}}</span>
      </template>
    </van-cell>
    <van-cell  icon="wap-home-o">
      <template #title>
        <span class="custom-title2">{{C_Address}}</span>
      </template>
    </van-cell>

    <div class="margin1"/>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-cell-group v-for="(item) in list" :key="item.id">
          <van-cell  v-model="item.Tr_Time" icon="calendar-o" size="large">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title">缴费日期  </span>
              <van-tag type="primary">{{item.Tr_PayMode}}</van-tag>
            </template>
          </van-cell>
          <van-cell title="缴费金额" v-model="item.Tr_Pay" icon="gold-coin-o"/>
          <van-cell title="抄表日期" v-model="item.FA_NDate" icon="notes-o"/>
          <van-cell title="用气量" v-model="item.FA_Count" icon="bar-chart-o"/>
        </van-cell-group>

      </van-list>
    </van-pull-refresh>


  </div>
</template>
<script>
import API from './../api/index';
import {Toast} from "vant";
//import { Toast } from 'vant';
export default {
  name: 'page_jfjl',
  data() {
    return {
      C_ID:"",
      C_Code:"",
      C_Name:"",
      C_Address:"",
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },
    getCust() {
      if (this.$cookie.get('CID')===''||!this.$cookie.get('CID')) {
        Toast('请先绑定用户！')
        this.$router.push('/bindlist');
      } else {
        this.C_ID=this.$cookie.get('CID');
        this.C_Code=this.$cookie.get('C_Code');
        this.C_Address=this.$cookie.get('CAddress');
        this.C_Name=this.$cookie.get('CName');
      }

    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        this.$http.get(API.LookTradeByWX,{
          params: {
            c_id:this.C_ID
          }
        })
            .then((response)=>{
              let res = response.data;
              if (res.code == 0) {
                this.list=res.subdata;
                this.$cookie.set('trade',res.subdata,  { expires: '360m' });
              } else {
                this.loading = false;
                this.finished= true;
              }
            });

        this.loading = false;

        if (this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    }
  },
  mounted () {
    this.getCust();
  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.margin1{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.margin0{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

</style>